import { client } from "api";
import { TimeEntry } from "models/TimeEntry";

export type FilterTimeEntriesRequest = {
  searchQuery: string;
  fromDate: string | null;
  toDate: string | null;
  state: "PENDING" | "APPROVED" | "REJECTED" | null;
  type: number | null;
  processed: boolean | null;
  orderByEmployeeNumber: boolean;
};

export type FilterTimeEntriesResponse = {
  resultsCount: number;
  page: number;
  pageCount: number;
  results: TimeEntry[];
};

export const filterTimeEntries = (
  request: FilterTimeEntriesRequest
): Promise<FilterTimeEntriesResponse> =>
  client.post<FilterTimeEntriesResponse>("/absence/filter", request).then((res) => res.data);
